import { useEffect } from 'react';

import {
  ORG_MANAGE_DETAILS_NOTES,
  ORG_PROFILE_SETTINGS,
} from '@constants/routes';

import { useNavigate } from '@hooks/useNavigate';

import { getQueryParams } from '@utils/url';

export default function AccountIdManagementPage() {
  const { navigateRoute } = useNavigate();
  const { account_id } = getQueryParams();
  const id = Array.isArray(account_id) ? account_id.at(0) : account_id;

  useEffect(() => {
    navigateRoute(
      id ? ORG_MANAGE_DETAILS_NOTES : ORG_PROFILE_SETTINGS,
      id ? { account_id: id } : undefined
    );
  }, [id, navigateRoute]);

  return null;
}
